export const ApplicationRoles = {
    Administrator: "Administrator",
    AOFOpener: "AOFOpener",
    BossApprover: "BossApprover",
    CreditRisk: "CreditRisk",
    CreditRiskDirector: "CreditRiskDirector",
    LogisticDocumentation: "LogisticDocumentation",
    LogisticCustomerService: "LogisticCustomerService",
    LogisticPlanning: "LogisticPlanning",
    LogisticPlanningPerfumes: "LogisticPlanningPerfumes",
    AccountReceivable: "AccountReceivable",
    ViewOnlyJWA: "ViewOnlyJWA",
    ViewOnlyPerfumes: "ViewOnlyPerfumes",
    DataQuality: "DataQuality",
    ProcessOwner: "ProcessOwner",
    PricingUnit: "PricingUnit"
};

export const SapTableNames = {
    CG4: "CG4",
    Companies: "Companies",
    Countries: "Countries",
    CreditControlAreas: "Credit Control Areas",
    Currencies: "Currencies",
    CustomerGroups: "Customer Groups",
    CustomerGroups6: "Customer Groups 6",
    CustomerGroups10: "Customer Groups 10",
    DistributionChannels: "Distribution Channels",
    CustomerTypes: "Customer Types",
    DeliveryPriorities: "Delivery Priorities",
    Incoterms: "Incoterms",
    PricingGroups: "Pricing Groups",
    PricingLists: "Pricing Lists",
    RequestedDeliveryDateMandatory: "Requested Delivery Date Mandatory",
    ResponsibilityAreas: "Responsibility Areas",
    SalesDistricts: "Sales Districts",
    SalesGroups: "Sales Groups",
    SalesOffices: "Sales Offices",
    SalesOrganizations: "Sales Organizations",
    ShippingConditions: "Shipping Conditions",
    States: "States",
    TransportationZones: "Transportation Zones",
    PaymentTerms: "Payment Terms",
    Divisions: "Divisions",
    AccountGroups: "Account Groups",
    AccountAssignmentGroup: "Account Assignment Groups",
    AccountingClerks: "Accounting Clerks",
    CashManagementGroups: "Cash Management Groups",
    ReconcilationAccounts: "Reconcilation Accounts",
    SortKeys: "Sort Keys",
    Chains: "Chains",
    DeliveringPlants: "Delivering Plants",
    DunningProcedures: "Dunning Procedures",
    InfoTypes: "Info Types",
    Segments: "Segments"
};

export const LocalTableNames = {
    BusinessCategories: "Business Categories",
    PrincipalOperationCountries: "Principal Operation Countries",
    Ratings: "Ratings"
};

export const AppSettingNames = {
    ItalyCountryId: "ItalyCountryId",
    PerfumesBusinessCategoryId: "PerfumesBusinessCategoryId",
    AccGroupNoBankInfoIds: "AccGroupNoBankInfoIds",
    AccountStatement: "Account statement",
    Authorization: "Authorization",
    ExchangeRateType: "Exchange rate type",
    FlagPaymentHistory: "Flag payment history",
    PreviusAccountNumber: "Previus Account Number",
    PricingProcedure: "Pricing procedure",
    StatisticsGroup: "Statistics group",
    DivisionPerfumes: "Division perfumes",
    DivisionJWA: "Division JWA",
    AccGrSH: "Acc_gr_SH"
};

export const AppSettingsType = {
    Local: 0,
    Sap: 1
};

export const RequestStatus = {
    Draft: 0,
    ToBeReviewed: 1,
    BossApproval: 2,
    CreditRiskEvaluation: 3,
    CreditRiskApproval: 4,
    Logistic: 5,
    WaitingForContract: 6,
    AccountReceivableApproval: 7,
    WaitingToBeAddedInSap: 8,
    Approved: 9,
    Rejected: 10,
    CreditRiskReEvaluation: 11,
    Deleted: 12,
    SapError: 13,
    Blocked: 14,
    Closed: 15,
    PricingUnit: 16
};

export const TodoAction = {
    OpenRequest: 0,
    OpenRolesList: 1
};

export const DbType = {
    ECC: 0,
    S4: 1
};